<template>
<div class="container-fluid mt-3 mb-3" :key="componentKey">
    <div class="row">

        <div class="col-xl-8 col-lg-10 col-md-12 order-2 order-md-1 col-12 ml-auto mr-auto" v-if="!calculated">
            <h1 class="h3 text-center mb-3 text-dark"><i class="fas fa-cogs text-primary"></i> Setup calculation</h1>
            <div class="row">
                <div class="col-md-4 text-center mt-0 pt-3 pb-0 pl-3 pr-3 card bg-light border-0 shadow-sm">
                    <div class="card-body">
                        <fieldset class="form-group">
                            <label for="fefco" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-1 mb-3">1. Select FEFCO</label>
                            <select class="custom-select" id="fefco" v-model="options.fefco" @change="changeFefco">
                                <option v-for="(fefco, i) in fefcos" :value="fefco.id">{{ fefco.code }}</option>
                            </select>
                        </fieldset>
                        <img @click="showFefcoImage()" v-if="fefcoImage.length > 0" :src="fefcoImage" class="img-fluid shadow-sm mt-0 mb-2 border-1" alt="" style="cursor: pointer;">
                    <fieldset class="form-group mt-4">
                        <label for="price_total" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-1 mb-3">2. Select dimensions (mm)</label>
                        <div class="row no-gutters">
                            <div class="col-4">
                                <label for="dimension_length">Length</label>
                                <input class="form-control" type="number" name="dimension_length" v-model="options.dimensions.length" id="dimension_length">
                            </div>
                            <div class="col-4">
                                <label for="dimension_breadth">Breadth</label>
                                <input class="form-control" type="number" name="dimension_breadth" v-model="options.dimensions.breadth" id="dimension_breadth">
                            </div>
                            <div class="col-4">
                                <label for="dimension_height">Height</label>
                                <input class="form-control" type="number" name="dimension_height" v-model="options.dimensions.height" id="dimension_height">
                            </div>
                        </div>
                    </fieldset>
                    <fieldset class="form-group mt-4">
                        <label for="materials" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-1 mb-3">3. Choose material</label>
                        <select class="custom-select form-control" id="materials" v-model="options.material">
                            <option v-for="(material, i) in materials" :value="material.id">{{ material.name }}</option>
                        </select>
                    </fieldset>

                    <fieldset class="form-group mt-4">
                        <label for="amounts" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-1 mb-3">4. Amounts</label>
                            <input type="text" class="form-control mb-1" v-model="rows[0].amount">
                            <input type="text" class="form-control mb-1" v-model="rows[1].amount">
                            <input type="text" class="form-control mb-1" v-model="rows[2].amount">
                            <input type="text" class="form-control mb-1" v-model="rows[3].amount">
                            <input type="text" class="form-control" v-model="rows[4].amount">
                    </fieldset>
                    <button class="btn btn-block btn-lg mt-4 font-weight-bold btn-primary text-warning ld-ext-right" @click="calculate()" :disabled="options.fefco.length === 0 || options.material.length === 0" :class="{running: isLoading}"><i class="fas fa-calculator"></i> Calculate <i class="fas fa-spinner fa-pulse ld text-warning"></i></button>



                    </div>
                </div>
                <div class="col-12 col-md-4 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <label for="options_markup" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">Price markup</label>
                        <select class="custom-select form-control" id="options_markup" v-model="options.markup">
                            <option v-for="(mup, i) in procentages" :value="mup.value">{{ mup.key }}</option>
                        </select>
                    </fieldset>

                    <fieldset class="form-group">
                        <label for="options_extra_discount" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">Extra discount</label>
                        <select class="custom-select form-control" id="options_extra_discount" v-model="options.extra_discount">
                            <option v-for="(dis, i) in procentages" :value="dis.value">{{ dis.key }}</option>
                        </select>
                    </fieldset>

                    <fieldset class="form-group">
                        <div class="row">
                            <div class="col-12">
                                <label class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 mb-3" for="eur_pallet_size">EUR pallets height</label>
                                <input class="form-control" type="number" name="dimension_length" v-model="options.eur_pallets_height" id="eur_pallet_size">
                                <small>Size in mm.</small>
                            </div>
                            <div class="col-12 mt-4">
                                <label class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 mb-3" for="currency">Currency</label>
                                 <select class="custom-select form-control" id="currency" v-model="options.currency" @change="changeCurrency">
                                    <option v-for="(currency, i) in currencies" :value="currency.id">{{ currency.symbol_text }}</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>
                    </div>
                                <div class="col-12 col-md-4 text-center mt-1 pt-3 pb-0 pl-3 pr-3">

                <div class="pl-4 form-check">
                    <fieldset class="text-left form-group mb-3">
                        <input type="checkbox" id="with_handle" name="with_handle" class="form-check-input">
                        <label for="with_handle" class="form-check-label size-80">Handle</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="without_print1" name="print" class="form-check-input" v-model="options.extras.print" value="without_print">
                        <label for="without_print1" class="form-check-label size-80">Without print</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="flexoprint_1_f" name="print" class="form-check-input" v-model="options.extras.print" value="flexoprint_1_f">
                        <label for="flexoprint_1_f" class="form-check-label size-80">Flexoprint 1 color</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="flexoprint_2_f" name="print" class="form-check-input" v-model="options.extras.print" value="flexoprint_2_f">
                        <label for="flexoprint_2_f" class="form-check-label size-80">Flexoprint 2 color</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="digitalprint_1_30" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_1_30">
                        <label for="digitalprint_1_30" class="form-check-label size-80">Digital print 1-30 %</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="digitalprint_30_80" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_30_80">
                        <label for="digitalprint_30_80" class="form-check-label size-80">Digital print 30-80 %</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="digitalprint_80_100" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_80_100">
                        <label for="digitalprint_80_100" class="form-check-label size-80">Digital print 80-100 %</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_1_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_1_f">
                        <label for="screenprint_1_f" class="form-check-label size-80">Screentryck 1 f</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_1_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_1_f_50_100">
                        <label for="screenprint_1_f_50_100" class="form-check-label size-80">Screentryck 1 f 50-100%</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_2_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_2_f">
                        <label for="screenprint_2_f" class="form-check-label size-80">Screentryck 2 f</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_2_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_2_f_50_100">
                        <label for="screenprint_2_f_50_100" class="form-check-label size-80">Screentryck 2 f 50-100%</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_3_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_3_f">
                        <label for="screenprint_3_f" class="form-check-label size-80">Screentryck 3 f</label>
                    </fieldset>
                    <fieldset class="text-left form-group mb-1">
                        <input type="radio" id="screenprint_3_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_3_f_50_100">
                        <label for="screenprint_3_f_50_100" class="form-check-label size-80">Screentryck 3 f 50-100%</label>
                    </fieldset>
                </div>
                </div>
            </div>
        </div>

        <div class="mt-4 mt-sm-0 col-12 order-2 order-md-1 col-md-3 ml-auto mr-auto card bg-light pt-3 pb-0 pl-3 pr-3 border-0" v-if="calculated">
            <h1 class="h5 mt-2 font-weight-bold text-center mb-1 text-dark"><i class="fas fa-cogs text-primary"></i> Options</h1>
            <div class="row">
                <div class="col-md-12 text-center mt-0">
                    <div class="card-body">
                        <fieldset class="form-group">
                            <label for="fefco_options" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">1. Select FEFCO</label>
                            <select class="custom-select" id="fefco" v-model="options.fefco" @change="changeFefco">
                                <option v-for="(fefco, i) in fefcos" :value="fefco.id">{{ fefco.code }}</option>
                            </select>
                        </fieldset>
                        <img @click="showFefcoImage()" v-if="fefcoImage.length > 0" :src="fefcoImage" class="img-fluid shadow-sm mt-0 mb-2 border-1" alt="" style="cursor: pointer;">
                    </div>
                </div>
                <div class="col-md-12"><hr class="mt-2 mb-2"></div>
                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <label for="price_total" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">2. Select dimensions (mm)</label>
                        <div class="row no-gutters">
                            <div class="col-4">
                                <label class="small font-weight-bold" for="dimension_length">Length</label>
                                <input class="form-control form-control-sm" type="number" name="dimension_length" v-model="options.dimensions.length" id="dimension_length">
                            </div>
                            <div class="col-4">
                                <label class="small font-weight-bold" for="dimension_breadth">Breadth</label>
                                <input class="form-control form-control-sm" type="number" name="dimension_breadth" v-model="options.dimensions.breadth" id="dimension_breadth">
                            </div>
                            <div class="col-4">
                                <label class="small font-weight-bold" for="dimension_height">Height</label>
                                <input class="form-control form-control-sm" type="number" name="dimension_height" v-model="options.dimensions.height" id="dimension_height">
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="col-md-12"><hr class="mt-2 mb-2"></div>
                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <label for="options_materials" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">3. Choose material</label>
                        <select class="custom-select form-control" id="options_materials" v-model="options.material">
                            <option v-for="(material, i) in materials" :value="material.id">{{ material.name }}</option>
                        </select>
                    </fieldset>
                </div>
                <div class="col-md-12"><hr class="mt-2 mb-2"></div>
                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <label for="options_markup" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">Price markup</label>
                        <select class="custom-select form-control" id="options_markup" v-model="options.markup">
                            <option v-for="(mup, i) in procentages" :value="mup.value">{{ mup.key }}</option>
                        </select>
                    </fieldset>
                </div>
                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <label for="options_extra_discount" class="text-dark badge badge-light-dark pl-3 pr-3 pt-2 pb-2 size-80 mb-3">Extra discount</label>
                        <select class="custom-select form-control" id="options_extra_discount" v-model="options.extra_discount">
                            <option v-for="(dis, i) in procentages" :value="dis.value">{{ dis.key }}</option>
                        </select>
                    </fieldset>
                </div>
                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3 form-check" v-if="calculated">
                    <fieldset class="form-group mb-3">
                        <input type="checkbox" id="with_handle" name="with_handle" class="form-check-input">
                        <label for="with_handle" class="form-check-label size-80">Handle</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="without_print1" name="print" class="form-check-input" v-model="options.extras.print" value="without_print">
                        <label for="without_print1" class="form-check-label size-80">Without print</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="flexoprint_1_f" name="print" class="form-check-input" v-model="options.extras.print" value="flexoprint_1_f">
                        <label for="flexoprint_1_f" class="form-check-label size-80">Flexoprint 1 color</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="flexoprint_2_f" name="print" class="form-check-input" v-model="options.extras.print" value="flexoprint_2_f">
                        <label for="flexoprint_2_f" class="form-check-label size-80">Flexoprint 2 color</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="digitalprint_1_30" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_1_30">
                        <label for="digitalprint_1_30" class="form-check-label size-80">Digital print 1-30 %</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="digitalprint_30_80" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_30_80">
                        <label for="digitalprint_30_80" class="form-check-label size-80">Digital print 30-80 %</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="digitalprint_80_100" name="print" class="form-check-input" v-model="options.extras.print" value="digitalprint_80_100">
                        <label for="digitalprint_80_100" class="form-check-label size-80">Digital print 80-100 %</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_1_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_1_f">
                        <label for="screenprint_1_f" class="form-check-label size-80">Screentryck 1 f</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_1_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_1_f_50_100">
                        <label for="screenprint_1_f_50_100" class="form-check-label size-80">Screentryck 1 f 50-100%</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_2_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_2_f">
                        <label for="screenprint_2_f" class="form-check-label size-80">Screentryck 2 f</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_2_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_2_f_50_100">
                        <label for="screenprint_2_f_50_100" class="form-check-label size-80">Screentryck 2 f 50-100%</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_3_f" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_3_f">
                        <label for="screenprint_3_f" class="form-check-label size-80">Screentryck 3 f</label>
                    </fieldset>
                    <fieldset class="form-group mb-1">
                        <input type="radio" id="screenprint_3_f_50_100" name="print" class="form-check-input" v-model="options.extras.print" value="screenprint_3_f_50_100">
                        <label for="screenprint_3_f_50_100" class="form-check-label size-80">Screentryck 3 f 50-100%</label>
                    </fieldset>
                </div>

                <div class="col-md-12 text-center mt-1 pt-3 pb-0 pl-3 pr-3">
                    <fieldset class="form-group">
                        <div class="row">
                            <div class="col-12">
                                <label class="small font-weight-bold" for="eur_pallet_size">EUR pallets height</label>
                                <input class="form-control" type="number" name="dimension_length" v-model="options.eur_pallets_height" id="eur_pallet_size">
                                <small>Size in mm.</small>
                            </div>
                            <div class="col-12 mt-2">
                                <label class="small font-weight-bold" for="currency">Currency</label>
                                 <select class="custom-select form-control" id="currency" v-model="options.currency" @change="changeCurrency">
                                    <option v-for="(currency, i) in currencies" :value="currency.id">{{ currency.symbol_text }}</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="w-100 text-center mt-3">

                </div>
            </div>
        </div>

        <div class="col" v-if="calculated">
            <div class="col-12 text-center">
                <h2 class="h1 text-dark mt-3"><i class="fas fa-calculator text-primary"></i> Calculator</h2>
                <small>All prices are calculated without including cost of printfiles and matrices, when they are necessary.</small>

                <button class="btn btn-secondary float-right" 
                        @click="generatePDF()" 
                        :disabled="!calculated || isLoading">
                    <i class="fas fa-file-pdf"></i> Save as PDF
                </button>
            </div>
            <div class="table-responsive">
            <table class="table table-striped mt-2">
                <thead class="">
                    <tr>
                        <th class="small font-weight-bold border-0" style="width:105px">Amount</th>
                        <th class="small font-weight-bold border-0">Price ({{ selectedCurrencyText }})</th>
                        <th class="small font-weight-bold border-0">Price per box ({{ selectedCurrencyText }})</th>
                        <th class="small font-weight-bold border-0">Weight (kg)</th>
                        <th class="small font-weight-bold border-0">Volume (m<sup>3</sup>)</th>
                        <th class="small font-weight-bold border-0">No. EUR pallets</th>
                        <th class="small font-weight-bold border-0"></th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr v-for="(row, i) in rows">
                        <td class="border-0"><input type="number" class="form-control" name="amount" v-model="row.amount"></td>
                        <td class="border-0"><span class="pl-0 pr-0 form-control text-primary border-0 bg-transparant size-1 font-weight-bold">{{ row.price  }}</span></td>
                        <td class="border-0"><span class="pl-0 pr-0 form-control text-primary border-0 bg-transparant size-1">{{ row.price_per_box  }}</span></td>
                        <td class="border-0"><span class="pl-0 pr-0 form-control border-0 bg-transparant size-1">{{ row.weight }}</span></td>
                        <td class="border-0"><span class="pl-0 pr-0 form-control border-0 bg-transparant size-1">{{ row.volume }}</span></td>
                        <td class="border-0"><span class="pl-0 pr-0 form-control border-0 bg-transparant size-1">{{ row.eur_pallets }}</span></td>
                        <td class="border-0"><button v-if="row.log.length > 0" class="btn btn-sm btn-warning" @click="showLog(row.log, row.amount)"><i class="fas fa-clipboard-list"></i></button></td>
                    </tr>
                </tbody>
            </table>
            </div>
            <div class="w-100 text-center">
                <span class="pl-2 pr-2 text-center d-inline-block d-sm-none badge badge-dark"><i class="fas fa-arrow-left"></i> scroll for more <i class="fas fa-arrow-right"></i></span>
            </div>
            <div class="col-12 mt-2 ml-auto mr-auto" v-if="validationErrors.length > 0">
                <div class="alert alert-danger">
                    <ul class="mb-0 list-unstyled">
                        <li v-for="(error,i) in validationErrors"><i class="fas fa-times"></i> {{ error }}</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 col-12 mt-4 ml-auto mr-auto">
                <label for="notes" class="d-print-none">Notes:</label>
                <textarea class="form-control" rows="2" v-model="notes"></textarea>
            </div>
            <div class="col-md-6 col-12 mt-4 ml-auto mr-auto">
                <button class="btn btn-block size-150 btn-lg font-weight-bold btn-primary text-warning ld-ext-right" @click="calculate()" :disabled="options.fefco.length === 0 || options.material.length === 0" :class="{running: isLoading}"><i class="fas fa-calculator"></i> Calculate <i class="fas fa-spinner fa-pulse ld text-warning"></i></button>
            </div>            
        </div>

    </div>

<div class="modal fade" id="logModal" tabindex="-1" role="dialog" aria-labelledby="logModalTitle" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="logModalTitle"><span class="font-weight-bold">Calculation log</span> - <span class="font-weight-bold">Amount:</span> {{ selectedAmount }} (Prices in SEK)</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ul class="list-unstyled">
            <li v-for="(log, i) in selectedLog">
                <div class="col-12" v-html="log">
                </div>
            </li>
        </ul>
      </div>
      <div class="modal-footer text-center">
        <button type="button" class="ml-auto mr-auto btn btn-dark" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>
    export default {
        props: ['materials','fefcos','currencies'],
        data() {
            return {
                isLoading: false,
                fefcoImage: '',
                calculated: false,
                selectedLog: '',
                selectedAmount: 0,
                selectedCurrencyText: 'SEK',
                componentKey: 0,
                notes: '',
                procentages: [
                    {key: '0', value: 0},{key: '1%', value: 1.01},{key: '2%', value: 1.02},{key: '3%', value: 1.03},{key: '4%', value: 1.04},{key: '5%', value: 1.05},{key: '6%', value: 1.06},{key: '7%', value: 1.07},{key: '8%', value: 1.08},{key: '9%', value: 1.09},{key: '10%', value: 1.1},{key: '11%', value: 1.11},{key: '12%', value: 1.12},{key: '13%', value: 1.13},{key: '14%', value: 1.14},{key: '15%', value: 1.15},{key: '16%', value: 1.16},{key: '17%', value: 1.17},{key: '18%', value: 1.18},{key: '19%', value: 1.19},{key: '20%', value: 1.2},{key: '21%', value: 1.21},{key: '22%', value: 1.22},{key: '23%', value: 1.23},{key: '24%', value: 1.24},{key: '25%', value: 1.25},{key: '26%', value: 1.26},{key: '27%', value: 1.27},{key: '28%', value: 1.28},{key: '29%', value: 1.29},{key: '30%', value: 1.3},{key: '31%', value: 1.31},{key: '32%', value: 1.32},{key: '33%', value: 1.33},{key: '34%', value: 1.34},{key: '35%', value: 1.35},{key: '36%', value: 1.36},{key: '37%', value: 1.37},{key: '38%', value: 1.38},{key: '39%', value: 1.39},{key: '40%', value: 1.4},{key: '41%', value: 1.41},{key: '42%', value: 1.42},{key: '43%', value: 1.43},{key: '44%', value: 1.44},{key: '45%', value: 1.45},{key: '46%', value: 1.46},{key: '47%', value: 1.47},{key: '48%', value: 1.48},{key: '49%', value: 1.49},{key: '50%', value: 1.5},{key: '51%', value: 1.51},{key: '52%', value: 1.52},{key: '53%', value: 1.53},{key: '54%', value: 1.54},{key: '55%', value: 1.55},{key: '56%', value: 1.56},{key: '57%', value: 1.57},{key: '58%', value: 1.58},{key: '59%', value: 1.59},{key: '60%', value: 1.6},{key: '61%', value: 1.61},{key: '62%', value: 1.62},{key: '63%', value: 1.63},{key: '64%', value: 1.64},{key: '65%', value: 1.65},{key: '66%', value: 1.66},{key: '67%', value: 1.67},{key: '68%', value: 1.68},{key: '69%', value: 1.69},{key: '70%', value: 1.7},{key: '71%', value: 1.71},{key: '72%', value: 1.72},{key: '73%', value: 1.73},{key: '74%', value: 1.74},{key: '75%', value: 1.75},{key: '76%', value: 1.76},{key: '77%', value: 1.77},{key: '78%', value: 1.78},{key: '79%', value: 1.79},{key: '80%', value: 1.8},{key: '81%', value: 1.81},{key: '82%', value: 1.82},{key: '83%', value: 1.83},{key: '84%', value: 1.84},{key: '85%', value: 1.85},{key: '86%', value: 1.86},{key: '87%', value: 1.87},{key: '88%', value: 1.88},{key: '89%', value: 1.89},{key: '90%', value: 1.9},{key: '91%', value: 1.91},{key: '92%', value: 1.92},{key: '93%', value: 1.93},{key: '94%', value: 1.94},{key: '95%', value: 1.95},{key: '96%', value: 1.96},{key: '97%', value: 1.97},{key: '98%', value: 1.98},{key: '99%', value: 1.99},{key: '100%', value: 2}
                ],
                rows: [
                    {amount: 5, price: 0, price_per_box: 0, volume: 0, weight: 0, eur_pallets: 0 , log: ''},
                    {amount: 50, price: 0, price_per_box: 0, volume: 0, weight: 0, eur_pallets: 0, log: ''},
                    {amount: 100, price: 0, price_per_box: 0, volume: 0, weight: 0, eur_pallets: 0, log: ''},
                    {amount: 500, price: 0, price_per_box: 0, volume: 0, weight: 0, eur_pallets: 0, log: ''},
                    {amount: 1000, price: 0, price_per_box: 0, volume: 0, weight: 0, eur_pallets: 0, log: ''}
                ],
                options: {
                  extra_discount: 0,
                  markup: 0,
                  eur_pallets_height: 2000,
                  currency: 1,
                  fefco: '',
                  material: '',
                  amount_1: 5,
                  amount_2: 50,
                  amount_3: 100,
                  amount_4: 500,
                  amount_5: 1000,
                  dimensions: {
                      length: 100,
                      breadth: 100,
                      height: 100
                  },
                  extras: {
                    print: 'without_print'
                  }
                },
                validationErrors: []
            }
        },
        methods: {
            generatePDF() {

                this.isLoading = true;
                
                // Find the selected FEFCO object to get the code
                const selectedFefco = this.fefcos.find(f => f.id === this.options.fefco);
                const fefcoCode = selectedFefco ? selectedFefco.code : '';
                
                // Find the selected material to get its name
                const selectedMaterial = this.materials.find(m => m.id === this.options.material);
                const materialName = selectedMaterial ? selectedMaterial.name : '';

                // Get the print option label from the DOM
                const printOptionLabel = document.querySelector(`label[for="${this.options.extras.print}"]`)?.textContent || this.options.extras.print;
                
                const pdfData = {
                    fefco: {
                        id: this.options.fefco,
                        code: fefcoCode,
                        image: `/img/fefco/${fefcoCode}.png`
                    },
                    material: {
                        id: this.options.material,
                        name: materialName
                    },
                    dimensions: this.options.dimensions,
                    amounts: {
                        amount_1: this.options.amount_1,
                        amount_2: this.options.amount_2,
                        amount_3: this.options.amount_3,
                        amount_4: this.options.amount_4,
                        amount_5: this.options.amount_5
                    },
                    pricing: {
                        markup: this.options.markup,
                        extra_discount: this.options.extra_discount,
                        currency: {
                            id: this.options.currency,
                            symbol: this.selectedCurrencyText
                        }
                    },
                    pallets: {
                        height: this.options.eur_pallets_height
                    },
                    printOptions: {
                        handle: document.getElementById('with_handle').checked,
                        print: this.options.extras.print,
                        printLabel: printOptionLabel
                    },
                    notes: this.notes,
                    results: this.rows.map(row => ({
                        amount: row.amount,
                        price: row.price,
                        price_per_box: row.price_per_box,
                        weight: row.weight,
                        volume: row.volume,
                        eur_pallets: row.eur_pallets
                    }))
                };

                axios.post('/api/v1/generate-pdf', pdfData, {
                    responseType: 'blob'
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `box-calculation-${Date.now()}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    this.isLoading = false;
                })
                .catch(error => {
                    console.error('Error generating PDF:', error);
                    this.isLoading = false;
                    if (error.response && error.response.data && error.response.data.errors) {
                        this.validationErrors = Object.values(error.response.data.errors).flat();
                    } else {
                        this.validationErrors = ['Error generating PDF. Please try again.'];
                    }
                });
            },
            forceRerender() {
              this.componentKey += 1;
            },
            showLog(log, amount) {
                this.selectedLog = log;
                this.selectedAmount = amount;
                $('#logModal').modal('show');
            },
            showFefcoImage() {
                this.$swal({
                    imageUrl: this.fefcoImage,
                    imageAlt: ''
                });
            },
            changeFefco(e) {
              this.$nextTick().then(() => {
                this.fefcoImage = '/img/fefco/' + e.target[e.target.value-1].outerText + '.png';
              });
            },
            changeCurrency(e) {
              this.$nextTick().then(() => {
                this.selectedCurrencyText = e.target[e.target.value-1].outerText;
              });
            },
            calculate() {
                window.scroll({
                 top: 0,
                 left: 0,
                 behavior: 'smooth'
                });
              let formData = new FormData();
              var that = this;
              this.isLoading = true;
              this.calculated = true;
              this.validationErrors = [];
              this.options.amount_1 = this.rows[0].amount;
              this.options.amount_2 = this.rows[1].amount;
              this.options.amount_3 = this.rows[2].amount;
              this.options.amount_4 = this.rows[3].amount;
              this.options.amount_5 = this.rows[4].amount;

              axios.post('/api/v1/calculate', this.options)
                .then(response => {
                  this.isLoading = false;
                  if(response.data.data) {
                      this.rows = response.data.data;
                  }
                })
                .catch(function (error) {
                    console.log(error);
                    that.isLoading = false;
                     if (error.response.status == 422) {
                        that.validationErrors = error.response.data.errors;
                      } else if(error.response.status == 500) {
                        that.validationErrors = ['Internal server error, this has been reported.'];
                      } else if(error.response.status == 402) {
                        that.validationErrors = [error.response.data.msg];
                        that.selectedLog = JSON.parse(error.response.data.data);
                        that.selectedAmount = that.rows[0].amount;
                        $('#logModal').modal('show');
                      } else {
                         that.validationErrors = [error.response.data.msg];
                      }
                    console.log(error);
                 });
            }
        },
        mounted() {
            console.log('Calculator component mounted.')
        }
    }
</script>
